import PropTypes from 'prop-types';

const shippingDestinationShape = PropTypes.oneOf(['cardholder_home', 'office', '', 'other']);

export default shippingDestinationShape;
